import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchUserTypes = createAsyncThunk("fetchUserTypes", async () => {
	const response = await axiosHttp.get(`user_types`);
	return response.data.data;
});

const UserTypeSlice = createSlice({
	name: "UserTypeSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchUserTypes.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchUserTypes.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchUserTypes.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default UserTypeSlice.reducer;
